module.exports = __webpack_public_path__ + "static/media/bhs_icon_team.540c9b38.png";